<div class="page-container nofondPage">
  <div class="main-container">
    <div class="container nofondPage-content">
      <app-logo
        [lockDevice]="'web'"
        [onlineSize]="['auto', logoHeight]"
        [onlineSizeH5]="['auto', logoHeight]"
        [sitSize]="[siteSizeWidth, logoHeight]"
        [sitSizeH5]="[siteSizeH5Width, logoHeight]"
        [clickable]="true"
      ></app-logo>
      <div class="nofondPage-content-bottom">
        <div class="tips">{{ 'notfound_tip_1' | translate }}</div>
        <div class="tips">{{ 'notfound_tip_2' | translate }}</div>
        <customize-button class="back" size="large-medium" width="34rem" type="primary-linear" (onClick)="goHome()">
          {{ 'go_home' | translate }}
        </customize-button>
      </div>
    </div>
  </div>
</div>
